/* eslint-disable @typescript-eslint/no-unused-expressions */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { findIndex } from 'lodash';
import { ListHeathIndicatorType, RQHeathIndicator } from './@define/type';

const initialState = {
  patient_list: {
    patients: [],
  } as any,
  select_patient: {} as any,
  heath_indicator_for_doctor: {} as ListHeathIndicatorType,
};

const patientSlice = createSlice({
  name: 'patient',
  initialState,
  reducers: {
    requestPatients: (_state, _action: PayloadAction<{ page?: number; limit?: number }>) => {},
    savePatients: (state, action: PayloadAction<{ data: any }>) => {
      const { data } = action.payload;

      state.patient_list = {
        ...data,
      };
    },
    clearPatientInList: (state, { payload: { id } }: PayloadAction<{ id: string }>) => {
      const index = findIndex(state.patient_list.patients, { id });
      state.patient_list.patients.splice(index, 1);
    },
    selectPatient: (state, action: PayloadAction<{ data: any }>) => {
      state.select_patient = action.payload.data;
    },

    resetPatients: (state, _action: PayloadAction) => {
      return Object.assign(state, initialState);
    },
    requestHeathIndicatorForDoctor: (_state, _action: RQHeathIndicator) => undefined,
    saveHeathIndicatorForDoctor: (state, action: PayloadAction<{ data: any }>) => {
      state.heath_indicator_for_doctor = action.payload.data;
    },
  },
});

export const patientActions = patientSlice.actions;
export default patientSlice;
